import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, NodeType, NodeTypeCategory } from "../Base";
import { DataType } from "../TypeDefinitions";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.uuidToString,
  label: "UUID To String",
  category: NodeTypeCategory.text,
  isExperimental: true,
  controlOutputs: [],
  dataInputs: [{ name: "a", type: DataType.UUID, hideLabel: true }],
  dataOutputs: [{ name: "result", type: DataType.STRING }],
  evaluate: (input: any) => {
    return {
      output: { result: input.a.toString() },
      activeControlHandleIds: []
    };
  }
});

export const UuidToStringNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
